// extracted by mini-css-extract-plugin
export default {"home":"Restaurant_home__TLQA2","body":"Restaurant_body__JJ71H"};